import { atom } from "jotai";

export type RerateDispatchOutcome = {
	poNumber: number;
	/** Null when the shipment wasn't dispatched, so no cancel was attempted. */
	cancelDispatchSuccess: boolean | null;
	/** Null when no redispatch was attempted (not dispatched, or cancel failed). */
	redispatchSuccess: boolean | null;
	/** When the rerate was tendered (epoch ms); unseen results go stale. */
	tenderedAt: number;
	/** Set when the banner first shows; the result is hidden after this time. */
	expiresAt?: number;
};

/**
 * Result of cancelling and redispatching a dispatched shipment when its rerate
 * is tendered. Set on the rerate carrier selection page and read by the
 * shipment page after navigating back, so it lives outside both pages.
 */
export const rerateDispatchOutcomeAtom = atom<RerateDispatchOutcome | null>(
	null,
);
